import React, { useState, useEffect, useContext } from 'react';
import Modal from 'react-modal';
import { AuthContext } from '../context/AuthContext';
import CommanderPicker from '../components/commanders/CommanderPicker';
import axiosInstance from '../utils/axiosInstance';
import './css/MergeCommanderModal.css';

const MergeCommanderModal = ({ isOpen, onRequestClose, selectedCommander, onMergeSuccess }) => {
    const axios = axiosInstance;
    const { user } = useContext(AuthContext);

    const getNationId = (nationValue) => {
        if (!nationValue) return '';
        if (typeof nationValue === 'object') {
            return String(nationValue._id || nationValue.id || '');
        }
        return String(nationValue);
    };

    const [foundCommander, setFoundCommander] = useState(null);

    useEffect(() => {
        if (isOpen) {
            setFoundCommander(null);
        }
    }, [isOpen]);

    const handleMerge = async () => {
        if (!foundCommander?._id) return alert('Please select a commander to merge with.');

        const confirmMerge = window.confirm(
            `Are you sure you want to merge ${selectedCommander.name} with ${foundCommander.name}?`
        );
        if (!confirmMerge) return;

        try {
            await axios.post(`/commanders/merge`, {
                commanderId1: selectedCommander._id,
                commanderId2: foundCommander._id,
            });
            alert('Commanders successfully merged!');
            onRequestClose();
            onMergeSuccess();
        } catch (error) {
            console.error('Error merging commanders:', error);
            alert('Failed to merge commanders. Please try again.');
        }
    };

    const searchNationId = getNationId(selectedCommander?.nation) || getNationId(user?.nation);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Merge Commanders"
            className="merge-commander-modal"
            overlayClassName="merge-commander-modal-overlay"
        >
            <h2>Merge Commanders</h2>
            <p>Merging commanders may be necessary when a player changes their name. This ensures the history of that commander is maintained.</p>

            <div className="commander-info">
                <h3>Existing Commander</h3>
                <p><strong>{selectedCommander.name}</strong> ({selectedCommander.alliance?.acronym || 'No Alliance'})</p>
                <p>Battle Power: {selectedCommander.battlePower.toLocaleString()}</p>
                <p>City Level: {selectedCommander.cityLevel}</p>
            </div>

            <div className="search-container">
                <h3>Search for Commander</h3>
                <CommanderPicker
                    value={String(foundCommander?._id || '')}
                    onChange={(commanderId, picked) => {
                        setFoundCommander(picked?.raw || (commanderId ? { _id: commanderId, name: picked?.commanderName } : null));
                    }}
                    mode="nation"
                    scopeId={searchNationId}
                    disabled={!searchNationId}
                    searchPlaceholder="Type or paste commander name"
                    placeholder="Select commander"
                />
            </div>

            {foundCommander && (
                <div className="commander-info">
                    <h3>Commander to Merge Into</h3>
                    <p><strong>{foundCommander.name}</strong> ({foundCommander.alliance?.acronym || 'No Alliance'})</p>
                    <p>Battle Power: {(foundCommander.battlePower || 0).toLocaleString()}</p>
                    <p>City Level: {foundCommander.cityLevel}</p>
                </div>
            )}

            <div className="modal-actions">
                <button onClick={onRequestClose} className="cancel-button">Cancel</button>
                <button onClick={handleMerge} className="merge-button" disabled={!foundCommander}>Merge</button>
            </div>
        </Modal>
    );
};

export default MergeCommanderModal;
